import { z } from 'zod';

import { DeepPartial, deepPartial } from '../deep-partial';
import { TeamSettings, teamSettingsSchema } from './team-settings';

export type UpdateTeamSettingsPayload = DeepPartial<TeamSettings>;

export const updateTeamSettingsPayloadSchema = deepPartial(teamSettingsSchema) as z.ZodType<
  UpdateTeamSettingsPayload,
  UpdateTeamSettingsPayload
>;
